<!--政策法规  -->
<template>
    <div class="policies-regulations">
       <!--  <div class="banner" :style="'background-image:url('+bannerBg+')'">
            <div class="banner-content">
                <div class="name">政策法规</div>
                <div class="instructions">提供及时、全面的土地政策法规</div>
            </div>
        </div> -->
         <div class="header">
             <span class="go-back" @click="goBack()">
                        <i class="iconfont icon-fanhui"></i>
                        <span>返回</span>
             </span>
            <span class="name">政策法规</span>
        </div>
        <div class="container">
            <!-- <div class="menu">
                <div class="title" :style="'background-image:url('+sideMenu+')'">
                    <span>政策法规</span>
                </div>
                <div>
                    <ul>
                        <li :class="menuActive === index? 'active': ''" @click="menuClick(index)" v-for="(item, index) in menuList" :key="'menuList'+index">
                            <i :style="'color:'+ colorList[index]" class="iconfont icon-zhengce"></i>
                            <span v-html="item.name"></span>
                        </li>
                    </ul>
                </div>
            </div> -->
            <div class="content">
                <el-scrollbar style="height: 100%;width: 100%;">
                   <el-empty v-show="resultList.length===0" :image-size="200"></el-empty>
                    <ul>
                        <li @click="policiesListClick(index)" :class="policiesListActive === index?'active': ''" v-for="(item, index) in resultList" :key="'policiesList'+index">
                            <div class="index">
                                <span v-html="index+1"></span>
                            </div>
                            <div class="notice">
                                <div class="name" v-html="item.name" @click="clickHandler(item)"></div>
                                <div class="source-time">
                                    <div class="source">
                                        <i class="iconfont icon-wenjianfayuan"></i>
                                        <span v-html="item.lx"></span>
                                    </div>
                                    <div class="time">
                                        <i class="iconfont icon-shijian"></i>
                                        <span v-html="item.createtime"></span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </el-scrollbar>
            </div>
        </div>
       <!--  <v-footer></v-footer> -->
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
/* import basemap from 'components/main-map/industrial-park-map' */
import bannerBg from '@/assets/images/policiesRegulations/banner.png'
import sideMenu from '@/assets/images/policiesRegulations/side_menu.png'
import vFooter from 'components/common/indexfooter'
import { mapResourceApi } from '@/api/mapResourceApi'
export default {
// import引入的组件需要注入到对象中才能使用
  components: {
    vFooter
  },
  data() {
    // 这里存放数据
    return {
      menuActive: 0,
      bannerBg,
      sideMenu,
      colorList: ['#FC1C38', '#E79123', '#DC6CB5'],
      menuList: [{
        name: '国家政策'
      }, {
        name: '省级政策'
      }, {
        name: '市级政策'
      }],
      resultList: [],
      policiesList: [],
      policiesList1: [],
      policiesListActive: -1
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getData () {
      this.queryData()
    },
    queryData() {
      const _this = this
      const params = {
        pageNo: 0,
        pageSize: 0,
        params: [
          {
            column: '',
            type: '',
            val: ''
          }
        ]
      }
      mapResourceApi.getRegulationsList(params).then(response => {
        if (response.code === '200') {
          this.resultList = []
          this.policiesList = []
          this.policiesList1 = []
          this.policiesList2 = []
          const list = response.data.list
          for (let i = 0; i < list.length; i++) {
            if (list[i].type == '1') {
              list[i].lx = '国家政策'
              this.policiesList.push(list[i])
            } else if (list[i].type == '2') {
              this.policiesList1.push(list[i])
              list[i].lx = '省级政策'
            } else if (list[i].type == '3') {
              this.policiesList2.push(list[i])
              list[i].lx = '市级政策'
            }
          }
          this.resultList = list
        } else {
          Notification.warning({
            title: '警告',
            message: '获取数据出错!',
            type: 'warning'
          })
          this.resultList = []
          this.policiesList = []
          this.policiesList1 = []
          this.policiesList2 = []
        }
      })
    },
    goBack() {
      this.$router.push(
        {name: 'mobileindex'}
      )
    },
    // menu点击
    menuClick(index) {
      this.menuActive = index
      if (index === 0) {
        this.resultList = this.policiesList
      } else if (index === 1) {
        this.resultList = this.policiesList1
      } else if (index === 2) {
        this.resultList = this.policiesList2
      }
    },
    // 选择
    policiesListClick(index) {
      this.policiesListActive = index
    },
    clickHandler(item) {
      const anorama = `${gisserverUrl}` + item.filepath
      window.open(anorama)
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getData()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //
    this.resultList = this.policiesList
  },
  beforeCreate() {
    //
  }, // 生命周期 - 创建之前
  beforeMount() {
    //
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
    //
  }, // 生命周期 - 更新之前
  updated() {
    //
  }, // 生命周期 - 更新之后
  beforeDestroy() {
    //
  }, // 生命周期 - 销毁之前
  destroyed() {
    //
  }, // 生命周期 - 销毁完成
  activated() {
    //
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
    .policies-regulations{
        width: 100%;
        height: 100%;
        text-align: left;
        background: #f7f8fa;
        overflow-x: hidden;
        .header{
            height: 2.2rem;
            line-height: 2.105rem;
            padding: 0rem 0.5rem;
            font-size: 0.7rem;
            text-align: center;
            border-bottom: 0.05rem solid #dedede;
            white-space: nowrap;
            overflow-x: auto;
            width: 100%;
            .go-back{
                    height: 1.2rem;
                    background: #4293f4;
                    border-radius: 0.2rem;
                    color: #ffffff;
                    cursor: pointer;
                    line-height: 1.2rem;
                    padding: 0px 0.4rem;
                    display: inline-block;
                    margin-right: 0.5rem;
                    float: left;
                    margin-top: 0.45rem;
                    i.iconfont{
                        font-size: 0.7rem;
                    }
            }
            .name{
                width: calc(100% - 3.4rem);
                text-align: center;
                display: inline-block;
            }
        }
        .banner{
            width: 100%;
            height: 160px;
            position: relative;
            background-size: 100% 100%;
            .banner-content{
                width: 1200px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                .name{
                    font-size: 40px;
                    font-weight: bold;
                    color: #ffffff;
                }
                .instructions{
                    margin-top: 10px;
                    font-size: 20px;
                    font-weight: normal;
                    color: #ffffff;
                }
            }
        }
        .container{
            height: calc(100% - 20px);
            padding: 20px 0px;
            width: 1200px;
            margin: 0px auto;
            display: flex;
            justify-content: space-between;
            .menu{
                width: 240px;
                height: 100%;
                background: #ffffff;
                margin-right: 20px;
                box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.1);
                .title{
                    height: 53px;
                    width: 100%;
                    background-size: 100%;
                    background-repeat: no-repeat;
                    font-size: 16px;
                    font-weight: bold;
                    color: #ffffff;
                    line-height: 53px;
                    text-align: center;
                }
                li{
                    height: 42px;
                    border-right: 3px solid transparent;
                    padding-left: 20px;
                    line-height: 42px;
                    font-size: 14px;
                    font-weight: 700;
                    color: #333333;
                    cursor: pointer;
                    i.iconfont{
                        font-size: 14px;
                        margin-right: 10px;
                    }
                    &:hover,&.active{
                        background: #eaf2fd;
                        border-right: 3px solid #2F80ED;
                    }
                }
            }
            .content{
                width: 940px;
                height: 100%;
                background: #ffffff;
                box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.1);
                padding: 20px 0px;
                ul{
                    padding: 0px 20px;
                    li{
                        padding: 15px 20px;
                        border-bottom: 1px solid #dedede;
                        display: flex;
                        justify-content: space-between;
                        cursor: pointer;
                        .index{
                            width: 24px;
                            height: 24px;
                            background: #f9f9f9;
                            box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.1);
                            font-size: 14px;
                            font-weight: bold;
                            color: #999999;
                            text-align: center;
                            line-height: 24px;
                            margin-right: 20px;
                        }
                        .notice{
                            width: calc(100% - 44px);
                            .name{
                                font-size: 16px;
                                font-weight: bold;
                                color: #333333;
                                line-height: 24px;
                            }
                            .source-time{
                                display: flex;
                                justify-content: space-between;
                                margin-top: 10px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #666666;
                                i.iconfont{
                                    font-size: 14px;
                                    margin-right: 5px;
                                }
                            }
                        }
                        &.active,&:hover{
                            background: rgba(234,242,253,0.40);
                            .index{
                                color: #2F80ED;
                            }
                            .notice {
                                .name {
                                    color: #2F80ED;
                                }
                            }
                        }
                    }
                }
                ::v-deep{
                    .el-scrollbar__wrap{
                        overflow-x: hidden;
                    }
                }
            }
        }
    }
</style>
